(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.ChartOutput = (function() {
    function ChartOutput(parent, dialog, sourceUrl, type, xAxes, yAxes, options1, getDataFn) {
      this.parent = parent;
      this.dialog = dialog;
      this.sourceUrl = sourceUrl;
      this.type = type != null ? type : 'bar';
      this.xAxes = xAxes != null ? xAxes : [];
      this.yAxes = yAxes != null ? yAxes : [];
      this.options = options1 != null ? options1 : {};
      this.getDataFn = getDataFn != null ? getDataFn : this.getData;
      this.getData = bind(this.getData, this);
      this.registerVerticalLinePlugin = bind(this.registerVerticalLinePlugin, this);
      this.registerVerticalLinePlugin();
      return;
    }

    ChartOutput.prototype.registerVerticalLinePlugin = function() {
      var verticalLinePlugin;
      verticalLinePlugin = {
        renderVerticalLine: function(chartInstance, line) {
          var context, lineLeftOffset, percentage, ref, xScale, yScale;
          xScale = chartInstance.scales['x-axis-0'];
          percentage = (line.value - xScale.min) / (xScale.max - xScale.min);
          lineLeftOffset = xScale.left + percentage * (xScale.right - xScale.left);
          yScale = chartInstance.scales['y-axis-0'];
          context = chartInstance.chart.ctx;
          context.beginPath();
          context.strokeStyle = (ref = line.color) != null ? ref : '#000000';
          context.lineWidth = line.width;
          context.moveTo(lineLeftOffset, yScale.top);
          context.lineTo(lineLeftOffset, yScale.bottom);
          return context.stroke();
        },
        afterDatasetsDraw: function(chart, easing) {
          var i, len, line, ref, results;
          if (chart.options.plugins.lineAtValues) {
            ref = chart.options.plugins.lineAtValues;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              line = ref[i];
              results.push(this.renderVerticalLine(chart, line));
            }
            return results;
          }
        }
      };
      return Chart.plugins.register(verticalLinePlugin);
    };

    ChartOutput.prototype.createChart = function() {
      var canvas, ctx, options;
      canvas = this.dialog.dialog.find('.chart');
      if (!(canvas.length > 0)) {
        return;
      }
      ctx = canvas[0].getContext('2d');
      options = $.extend(true, this.options, {
        scales: {
          xAxes: this.xAxes,
          yAxes: this.yAxes
        },
        responsiveAnimationDuration: 200
      });
      return this.chart = new Chart(ctx, {
        type: this.type,
        options: options
      });
    };

    ChartOutput.prototype.destroy = function() {
      var ref;
      return (ref = this.chart) != null ? ref.destroy() : void 0;
    };

    ChartOutput.prototype.getData = function() {
      return $.get(this.sourceUrl, {
        query: this.parent.filters
      });
    };

    ChartOutput.prototype.buildTable = function() {
      if (this.chart == null) {
        this.createChart();
      }
      if (this.chart == null) {
        return;
      }
      return this.getDataFn().then((function(_this) {
        return function(config) {
          var bg, dataset, datasets, gradient, i, len;
          $.extend(true, _this.chart.options, config.options);
          _this.chart.data.labels = config.data.labels || [];
          datasets = config.data.datasets;
          for (i = 0, len = datasets.length; i < len; i++) {
            dataset = datasets[i];
            bg = dataset.backgroundColor;
            if (typeof bg === 'object' && !Array.isArray(bg)) {
              gradient = _this.chart.ctx.createLinearGradient(0, _this.chart.ctx.canvas.height, 0, 0);
              gradient.addColorStop(0, bg.from);
              gradient.addColorStop(1, bg.to);
              dataset.backgroundColor = gradient;
            }
          }
          _this.chart.data.datasets = datasets;
          return _this.chart.update();
        };
      })(this));
    };

    ChartOutput.prototype.resizeTable = function() {};

    return ChartOutput;

  })();

}).call(this);
